import React from 'react';
import { Container, Typography, Box, Stack, Button } from '@mui/material';
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import TwitterIcon from '@mui/icons-material/Twitter';
import Experience from '../components/Experience';
import Education from '../components/Education';
import Certifications from '../components/Certifications';
import { useLanguageContext } from '../context/LanguageContext';
import { translations } from '../translations';

function About() {
  const { language } = useLanguageContext();
  const t = translations[language];

  return (
    <Container maxWidth="lg">
      <Box sx={{ mt: 8, minHeight: '100vh' }}>
        {/* Header Section */}
        <Box sx={{ mb: 6, textAlign: 'center' }}>
          <Typography variant="h2" component="h1" gutterBottom>
            {t.about.title}
          </Typography>
          <Typography 
            variant="body1" 
            paragraph 
            sx={{ 
              fontSize: '1.1rem',
              mb: 4,
              maxWidth: '800px',
              mx: 'auto',
              textAlign: 'justify'
            }}
          >
            {t.about.introduction}
          </Typography>
          <Stack 
            direction={{ xs: 'column', sm: 'row' }} 
            spacing={2} 
            sx={{ 
              mt: 4,
              justifyContent: 'center'
            }}
          >
            <Button 
              variant="outlined" 
              startIcon={<GitHubIcon />} 
              href={t.personalInfo.social?.github || "https://github.com"} 
              target="_blank"
              sx={{
                transition: 'transform 0.2s ease-in-out',
                '&:hover': {
                  transform: 'translateY(-2px)',
                },
              }}
            >
              GitHub
            </Button>
            <Button 
              variant="outlined" 
              startIcon={<LinkedInIcon />} 
              href={t.personalInfo.social?.linkedin || "https://linkedin.com"} 
              target="_blank"
              sx={{
                transition: 'transform 0.2s ease-in-out',
                '&:hover': {
                  transform: 'translateY(-2px)',
                },
              }}
            >
              LinkedIn
            </Button>
            {t.personalInfo.social?.twitter && (
              <Button 
                variant="outlined" 
                startIcon={<TwitterIcon />} 
                href={t.personalInfo.social?.twitter || "https://x.com"} 
                target="_blank"
                sx={{
                  transition: 'transform 0.2s ease-in-out',
                  '&:hover': {
                    transform: 'translateY(-2px)',
                  },
                }}
              >
                Twitter
              </Button>
            )}
            
          </Stack>
        </Box>

        {/* Experience Timeline */}
        <Experience />

        {/* Education Timeline */}
        <Education />

        {/* Certifications Grid */}
        <Certifications />
      </Box>
    </Container>
  );
}

export default About;
